import { JSONSchema7WithErrors } from '@cibo/core'
import { omit, pathEq } from 'ramda'
import { ITraitFeatureByIdYear } from '../types'
import { findInitialValuesDetail } from '../utils'
import SCHEMA from './schema.json'
import { RDWaterPumpIrrigation } from './types'
import { WaterPumpIrrigationCellDisplay } from './WaterPumpIrrigationDisplay'
import { WaterPumpIrrigationEditor } from './WaterPumpIrrigationEditor'
import { WaterPumpIrrigationEditorSimple } from './WaterPumpIrrigationEditorSimple'
import { WaterPumpIrrigationRollup } from './WaterPumpIrrigationRollup'

const TRAIT_ID = 'waterPumpIrrigation'

export const WaterPumpIrrigation: ITraitFeatureByIdYear<RDWaterPumpIrrigation> = {
  traitId: TRAIT_ID,
  cellDisplay: WaterPumpIrrigationCellDisplay,
  editor: WaterPumpIrrigationEditor,
  simpleEditor: WaterPumpIrrigationEditorSimple,

  forbidBulkEdit: false,
  initialValues: request => {
    const detail = findInitialValuesDetail(TRAIT_ID)(request)

    const formValues = detail?.input || {}

    return omit(['complete'], formValues)
  },
  ns: '@cibo/landmanager/WaterPumpIrrigation',

  validJsonSchema: ({ t }) => SCHEMA as JSONSchema7WithErrors,

  detailFromEditorValues: (formValues, requirement) => {
    const detail = {
      traitId: requirement?.traitId,
      year: requirement?.year,
      input: formValues.input,
    }

    if (!detail.input.pumpsUsed) {
      detail.input = omit(
        [
          'energySource',
          'energyAmount',
          'energyUnit',
          'totalWater',
          'waterUnit',
          'waterSource',
          'operatingPressurePSI',
          'pumpingDepthFeet',
          'surfaceWaterSource',
          'liftingOccurs',
        ],
        detail.input
      )
    }

    if (detail.input.energySource === 'unknown') {
      detail.input = omit(['energyAmount', 'energyUnit', 'userEnergyUnit'], detail.input)
    } else {
      detail.input = omit(
        [
          'totalWater',
          'waterUnit',
          'waterSource',
          'operatingPressurePSI',
          'pumpingDepthFeet',
          'surfaceWaterSource',
          'liftingOccurs',
        ],
        detail.input
      )
    }

    // backend requires unit, but it's known by source
    switch (detail.input.energySource) {
      case 'diesel':
        detail.input.energyUnit = 'gal'
        break
      case 'electricity':
      case 'renewable':
        detail.input.energyUnit = 'kWh'
        break
      default:
        break
    }

    return detail
  },

  rollups: {
    default: {
      traitId: TRAIT_ID,
      Component: WaterPumpIrrigationRollup,
      detailBaseValue: () => ({
        traitId: TRAIT_ID,
        input: {
          pumpsUsed: false,
        },
      }),
      isRollupValue: pathEq(['input', 'pumpsUsed'], false),
    },
  },
}
